export default "__VITE_ASSET__5EbKAtmv__"